import type { FaireProductEntity } from "../../entity_types/product";

export const p_vntmkzc5sw: FaireProductEntity = {
  token: "p_vntmkzc5sw",
  type: "product",
  name: "Hi-Chew Morinaga Strawberry Gummies 46g (Japan)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/79ced4c3e33a493f1a5bc9e48946dbf686d3b707a56d9887324a4d9624402f9b.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.62,
  description:
    "Hi-Chew Morinaga Strawberry Gummies – Juicy, Sweet & Made in Japan 🍓🍬🇯🇵\n\nIndulge in pure strawberry goodness with Hi-Chew Morinaga Strawberry Gummies, a Japan-exclusive gummy treat inspired by the classic Hi-Chew chew candy. These soft, bouncy gummies are packed with rich, fruity strawberry flavor, offering a juicy burst in every bite.\n\nPerfectly chewy and refreshingly sweet, they capture the essence of fresh Japanese strawberries, making them ideal for fruit candy lovers, Hi-Chew fans, and anyone who enjoys high-quality Japanese snacks.\n\nGreat for on-the-go snacking, candy bowls, or adding to a Japanese snack box!\n\n✅ Authentic Morinaga Hi-Chew product from Japan\n✅ Sweet, juicy strawberry flavor\n✅ Soft, bouncy, and easy-to-eat gummy texture\n✅ 46g pack—perfect for sampling or snacking\n✅ Great for strawberry candy lovers & Japan snack fans\n\nSize: 46g\nAllergens: May contain gelatin; check packaging for complete details.\n\n✨ Fruity, chewy, and irresistibly sweet—Hi-Chew Strawberry Gummies bring the taste of Japanese strawberries to every bite!\n",
  tags: [],
  msrpDollars: 4.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:38.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
